"use client";

import {
  formatMoney as newFormatMoney,
  IFormatMoneyProps,
} from "@faire/web--source/common/money";
import * as React from "react";

/**
 * @deprecated Use RoundingStrategy from web-common instead
 * Rounding strategy to use when intending to display whole numbers
 * of dollars only.
 *
 * If you only want to omit the cents when they're zero, use the
 * `omitCentsIfZero` attribute instead.
 */
export enum RoundingStrategy {
  /**
   * Amounts are not rounded.
   * This is the default behaviour.
   */
  NONE,
  /**
   * Rounds to the nearest dollar.
   */
  ROUND,
  /**
   * Drops the cents from the amount, rounding down (flooring) to
   * the nearest dollar.
   */
  DROP_CENTS,
  /**
   * Drops the cents from the amount, rounding up to the nearest
   * whole dollar.
   */
  DROP_CENTS_ROUND_UP,
}

export const Money: React.FunctionComponent<IFormatMoneyProps> = (props) => (
  <>{newFormatMoney(props)}</>
);

export namespace Money {
  export type IProps = IFormatMoneyProps;
}
